__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@portal/root";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@distribusion/portal-lib/auth", "0.29.22", () => (Promise.all([__webpack_require__.e(302), __webpack_require__.e(726), __webpack_require__.e(376), __webpack_require__.e(835), __webpack_require__.e(172)]).then(() => (() => (__webpack_require__(726))))));
			register("@distribusion/portal-lib/components", "0.29.22", () => (Promise.all([__webpack_require__.e(156), __webpack_require__.e(376), __webpack_require__.e(798), __webpack_require__.e(172), __webpack_require__.e(970), __webpack_require__.e(357)]).then(() => (() => (__webpack_require__(13156))))));
			register("@distribusion/portal-lib/i18n", "0.29.22", () => (Promise.all([__webpack_require__.e(784), __webpack_require__.e(798)]).then(() => (() => (__webpack_require__(93784))))));
			register("@distribusion/portal-lib/query-client", "0.29.22", () => (Promise.all([__webpack_require__.e(835), __webpack_require__.e(736)]).then(() => (() => (__webpack_require__(67736))))));
			register("@distribusion/portal-lib/translation", "0.29.22", () => (Promise.all([__webpack_require__.e(525), __webpack_require__.e(798)]).then(() => (() => (__webpack_require__(81525))))));
			register("@distribusion/portal-lib/user-settings", "0.29.22", () => (Promise.all([__webpack_require__.e(376), __webpack_require__.e(285)]).then(() => (() => (__webpack_require__(68285))))));
			register("i18next", "22.5.1", () => (__webpack_require__.e(995).then(() => (() => (__webpack_require__(93995))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(615), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(41615))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(153), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(60153))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(773), __webpack_require__.e(376), __webpack_require__.e(970)]).then(() => (() => (__webpack_require__(1773))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(46), __webpack_require__.e(510), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(49510))))));
			register("react", "18.2.0", () => (__webpack_require__.e(474).then(() => (() => (__webpack_require__(79474))))));
			initExternal(31881);
			initExternal(99095);
			initExternal(59866);
			initExternal(70766);
			initExternal(46123);
			initExternal(87510);
			initExternal(8334);
			initExternal(90515);
			initExternal(33726);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};